export default "__VITE_ASSET__CxWb6KZo__"